import { createFileRoute } from "@tanstack/react-router";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { CoachAthleteQuestionnairesPage } from "src/pages/CoachAthleteQuestionnairesPage";
import { createOrganizationQuestionnairesRepository } from "src/repositories/questionnaires/createOrganizationQuestionnairesRepository";
export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/",
)({
  component: CoachAthleteQuestionnairesPage,
  ssr: true,
  async loader({ context, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => ({
        data: await context.queryClient.query({
          ...createOrganizationQuestionnairesRepository(
            organization.id,
          ).listOptions(params.athleteId, { pageIndex: 0, pageSize: 20 }),
          staleTime: "static",
        }),
      }),
    );
  },
});
